import { forwardRef } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

const Textarea = forwardRef(function Textarea({
  classes = {},
  className,
  rows = "2",
  error = "",
  label,
  name,
  placeholder,
  type,
  disabled,
  isValidated = false,
  ...other
}, ref) {
  return (
    <label
      htmlFor={label}
      className={classNames(
        "textarea-component",
        disabled && "disabled",
        error && "border-danger",
        classes.root,
        className,
      )}
    >
      {label || name}
      <textarea
        id={label}
        type={type}
        className={classNames(
          "position-relative",
          disabled && "disabled",
          error && "border-danger",
          isValidated && "validated",
          classes.input,
        )}
        placeholder={placeholder || label || name}
        ref={ref}
        name={name}
        disabled={disabled}
        rows={rows}
        {...other}
      />
      <span
        className={classNames(
          "mt-1",
          "font-size-xs",
          "d-block",
          "text-danger",
          classes.error,
        )}
      >
        {error}
      </span>
    </label>
  );
});

Textarea.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  error: PropTypes.string,
  rows: PropTypes.string,
};

export default Textarea;
